export enum FormMode {
  CREATE = 'create',
  DUPLICATE = 'duplicate',
  EDIT = 'edit',
}

export const formModeUrlPattern = `:formMode(${Object.values(FormMode).join('|')})`
